export default [
    {
        path: 'relatorio-exame-imagem',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-exame-imagem' */
            '@/views/pronto-atendimento/relatorio-exame-imagem/Index'
        ),
        redirect: 'relatorio-exame-imagem/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-exame-imagem-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-exame-imagem' */
                    '@/views/pronto-atendimento/relatorio-exame-imagem/List'
                ),
            },
        ]
    }
]